import aesjs from 'aes-js'

const getKeyWithNumbers = numbers => {
  if (!(numbers instanceof Array)) {
    throw new Error('numbers should be array')
  }

  if (!numbers.every(num => typeof num === 'number')) {
    throw new Error('there are some weird shits in numbers array')
  }

  const key128 = [...numbers]
  for (let i = 0; i < 16 - numbers.length; i++) {
    key128.push(i)
  }
  return key128
}
/**
 * Encrypt some text with an array of numbers
 *
 * @param {number[]} key An array of numbers which is the key used to encrypt text
 * @param {string} text text that needed to be encrypted
 * @returns encrypted text in hex
 */
export const encrypt = (key, text) => {
  const key128 = getKeyWithNumbers(key)
  // eslint-disable-next-line
  const aesCtr = new aesjs.ModeOfOperation.ctr(key128, new aesjs.Counter(5));
  const textBytes = aesjs.utils.utf8.toBytes(text)
  const encryptedBytes = aesCtr.encrypt(textBytes)
  const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes)
  return encryptedHex
}

/**
 * Decrypt encrypted hex with an array of numbers
 *
 * @param {number[]} key An array of numbers which is the key used to decrypt encrypted hex
 * @param {string} encryptedHex encrypted hex that needed to be decrypted
 * @returns decrypted text
 */
export const decrypt = (key, encryptedHex) => {
  const key128 = getKeyWithNumbers(key)
  const encryptedBytes = aesjs.utils.hex.toBytes(encryptedHex)
  // eslint-disable-next-line
  const aesCtr = new aesjs.ModeOfOperation.ctr(key128, new aesjs.Counter(5));
  const decryptedBytes = aesCtr.decrypt(encryptedBytes)
  var decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes)
  return decryptedText
}
